
import React from 'react';

const HeroSection: React.FC = () => {
  return (
    <section className="bg-gradient-to-b from-itmgmt-light-blue to-white py-16 md:py-24">
      <div className="container-wide">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-itmgmt-dark-blue mb-6">
              Expert IT Support for Your Home
            </h1>
            <p className="text-lg text-gray-700 mb-8">
              We bring business-grade IT expertise to your home. Whether you need computer repairs, 
              network setup, security solutions, or smart home assistance, our experts are ready to help.
            </p>
            <div className="flex flex-wrap gap-4">
              <a href="#contact" className="button-primary bg-itmgmt-bright-blue hover:bg-itmgmt-medium-blue text-white px-6 py-3 rounded-md font-medium inline-flex items-center">
                Get Help Now
              </a>
              <a href="#services" className="button-secondary bg-white text-itmgmt-dark-blue border border-itmgmt-dark-blue px-6 py-3 rounded-md font-medium inline-flex items-center">
                View Services
              </a>
            </div>
          </div>
          <div className="rounded-lg overflow-hidden shadow-xl">
            <img 
              src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80" 
              alt="Modern home office setup" 
              className="w-full h-auto object-cover"
              width="800"
              height="533"
              loading="eager"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
